<div
  class="group relative tooltip-container"
  (click)="toggleTooltip($event)"
  (keydown.enter)="toggleTooltip($event)"
  (keydown.space)="toggleTooltip($event)"
  aria-describedby="tooltip-content"
  tabindex="0"
>
  <ng-content></ng-content>

  <div
    #tooltipContent
    [class.fixed]="useFixed"
    [class.absolute]="!useFixed"
    class="z-[9999] rounded shadow-lg transition-opacity duration-200 whitespace-nowrap pointer-events-none opacity-0 group-hover:opacity-100"
    [ngClass]="[
      useFixed ? '' : tooltipBoxClass,
      tooltipClass
        ? tooltipClass
        : 'px-3 py-2 text-sm text-black font-semibold bg-primary-lightest',
      isOpen ? 'opacity-100 pointer-events-auto' : ''
    ]"
    [ngStyle]="useFixed ? fixedStyles : {}"
  >
    {{ text }}
    <div class="absolute w-0 h-0" [ngClass]="triangleArrowClass"></div>
  </div>
</div>
